module.exports = __webpack_public_path__ + "static/PowerTrade-549d3699bc8e2baeaa1cb54c3f55a85d.png";